import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-lane-selector',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './lane-selector.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './lane-selector.component.scss',
})
export class LaneSelectorComponent {
  @Input() options: string[] = [];
  @Input() selectedLane = '';
  @Output() selectedLaneChange = new EventEmitter<string>();

  isOpen = false;

  constructor(private readonly elementRef: ElementRef<HTMLElement>) {}

  toggleDropdown(event: Event): void {
    event.stopPropagation();
    this.isOpen = !this.isOpen;
  }

  selectLane(lane: string, event: Event): void {
    event.stopPropagation();
    this.selectedLane = lane;
    this.selectedLaneChange.emit(lane);
    this.isOpen = false;
  }

  close(): void {
    this.isOpen = false;
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const target = event.target as HTMLElement | null;
    if (this.isOpen && target && !this.elementRef.nativeElement.contains(target)) {
      this.isOpen = false;
    }
  }
}
